import { ClassNamesConfig, StylesConfig } from 'react-select';

import { cn } from 'styles';

const sizeClasses = {
  small: 'min-h-8',
  medium: 'min-h-9',
  large: 'min-h-10',
};

const multiSizeClasses = {
  small: 'min-h-8',
  medium: 'min-h-9',
  large: 'min-h-10',
};

export type SelectVariantProps = {
  focusStyle?: 'outline' | 'border';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  containerClassName?: string;
};

type ClassNameResolverProps = SelectVariantProps & {
  anchoredOutside?: boolean;
};

export function getClassNames({
  focusStyle = 'border',
  size = 'medium',
  className,
  containerClassName,
  anchoredOutside,
}: ClassNameResolverProps): ClassNamesConfig {
  return {
    // min-height has to be removed from styles js object
    control: ({ isFocused, isDisabled, isMulti }) =>
      cn(
        isFocused &&
          (focusStyle === 'border'
            ? 'border-primary ring-1 ring-primary'
            : 'ring-2 ring-ring ring-offset-2'),

        !isFocused && 'border-input hover:border-gray-400',

        isDisabled && 'opacity-50',

        'rounded-md border bg-background hover:cursor-pointer',

        isMulti ? multiSizeClasses[size] : sizeClasses[size],

        className,
      ),

    container: () => containerClassName || '',

    placeholder: () => 'text-muted-foreground pl-3 py-0.5',

    input: () => 'pl-3 py-0.5',

    valueContainer: () => 'gap-1',

    singleValue: () => 'text-sm phone:text-base pl-3 text-secondary-foreground',

    multiValue: () =>
      'bg-muted text-muted-foreground rounded items-center py-0.5 pl-2 pr-1 gap-1.5 ml-1 text-sm phone:text-base select-none',
    multiValueLabel: () => 'py-0.5',
    multiValueRemove: () =>
      'border border-gray-200 bg-background hover:bg-red-50 hover:text-red-800 text-muted-foreground hover:border-red-300 rounded-md [&_svg]:w-3 [&_svg]:h-3',

    indicatorSeparator: () => 'bg-muted hidden',
    indicatorsContainer: () => cn('gap-1', size === 'small' ? 'p-0.5' : 'p-1'),
    dropdownIndicator: () =>
      cn(
        'rounded-md text-foreground hover:bg-muted',
        size === 'small' ? 'p-0.5 [&_svg]:h-4 [&_svg]:w-4' : 'p-1',
      ),

    clearIndicator: () => 'text-foreground p-1 rounded-md hover:bg-red-50 hover:text-red-800',

    menu: () => 'p-1 mt-2 border border-gray-200 bg-background rounded-lg',
    menuPortal: () => (anchoredOutside ? '!z-[100]' : ''),

    groupHeading: () => 'ml-3 mt-2 mb-1 text-foreground text-sm',

    noOptionsMessage: () => 'text-foreground p-2 rounded-sm',

    option: ({ isFocused, isSelected, isDisabled }) =>
      cn(
        isFocused && 'bg-muted active:bg-hover',
        // isSelected && "text-primary after:text-success after:content-['✔']",
        isSelected && 'text-primary',
        'flex items-center gap-2 rounded px-3 py-2',
        isDisabled ? 'italic opacity-50' : 'hover:cursor-pointer',
      ),
  };
}

export const styles: StylesConfig = {
  control: ({ minHeight: _, ...base }) => base,

  option: (base) => ({
    ...base,
    display: 'flex',
  }),
};
